import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          name: Yup.string()
                                                   .required('Required'),
                                          status: Yup.string()
                                                     .required('Required'),
                                          contactInfo: Yup.object()
                                                          .shape({
                                                                     email: Yup.string()
                                                                               .email('Invalid email')
                                                                               .required('Required'),
                                                                 })
                                                          .optional()
                                      });
